import moment from 'moment';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const RangeBoxYear = (props) => {
    const searchParams = useSelector(state => state.analyze.searchParams);
    const { selectedYear, currentSelectedYear } = props;
    const [searchParamYear, setSearchParamYear] = useState();
    const [years, setYears] = useState([2021, 2020, 2019, 2018]);
    const [isDisable, setDisabled] = useState();

    useEffect(() => {
        const startYear = moment.utc().year() - 4;
        const endYear = moment.utc().year();
        let data = [];

        for (let i = endYear; i >= startYear; i--) {
            data.push(i);
        }

        setYears(data);
    }, []);

    useEffect(() => {
        const searchYear = moment(searchParams.custom.from).year();
        const toYear = moment(searchParams.custom.from).year();
        let data = [];

        if (searchParams.custom.from !== null) {
            setSearchParamYear(searchYear);
        }

        if (searchYear !== toYear) {
            data.push("search")
        }

        if (searchParams.customRange === "todate" || searchParams.customRange === "planned") {
            setDisabled(true); setSearchParamYear(moment.utc().year());
        } else setDisabled(false);
        if (searchYear && currentSelectedYear && searchYear !== currentSelectedYear) {
            selectedYear(searchYear);
        }
    }, [searchParams]);

    const handleChange = e => selectedYear(e.target.value);

    return (
        <div>
            <select onChange={(e) => handleChange(e)} className='select-year' style={{
                backgroundColor: "transparent",
                color: "white",
                width: "65px",
                paddingLeft: "0px",
                border: "none",
                outline: "none",
                cursor: (isDisable) ? "not-allowed" : "pointer"
            }} disabled={isDisable}>
                {years.map(year => (searchParamYear === year ?
                    <option style={{ color: "blue", fontWeight: "bold" }} key={year} selected value={year}>{year}</option>
                    : <option style={{ color: "black" }} key={year} value={year}>{year}</option>))}
            </select>
        </div >
    )
}
export default memo(RangeBoxYear);
